import { render, staticRenderFns } from "./QuestionnaireInstanceFormDialog.vue?vue&type=template&id=63d7d7b3"
import script from "./QuestionnaireInstanceFormDialog.vue?vue&type=script&lang=js"
export * from "./QuestionnaireInstanceFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports